import { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Navbar,
  MobileNav,
  Typography,
  IconButton,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from '@material-tailwind/react';

import { BiChevronDown } from 'react-icons/bi';
import { RiArrowUpSFill } from 'react-icons/ri';
//==========import components and dummy data===============
import { navigationList } from 'helpers/commonHelper';
import DropDownMenuCard from 'components/common/cards/DropDownMenuCard';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Header = () => {
  const location = useLocation();
  const ref = useRef();
  const [openNav, setOpenNav] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const [menuName, setMenuName] = useState('');

  useEffect(() => {
    window.addEventListener(
      'resize',
      () => window.innerWidth >= 960 && (setOpenNav(false), setIsShown(true))
    );
  }, []);
  useEffect(() => {
    window.addEventListener(
      'resize',
      () => window.innerWidth <= 960 && (setOpenNav(false), setIsShown(false))
    );
  }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isShown && ref.current && !ref.current.contains(e.target)) {
        setIsShown(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isShown]);

  useEffect(() => {
    setCurrentUrl(location?.pathname);
  }, [location?.pathname]);

  return (
    <section className='DBlock'>
      <Navbar
        className={`
        } headerSec rounded-none min-w-full bg-transparent shadow-none filter-none border-none absolute top-0 py-1.5 lg:py-4 z-10 px-6 md:px-8`}>
        <div className='max-w-7xl mx-auto flex items-center text-white hover:text-white justify-between'>
          <NavLink to='/'>
            <img className='lg:w-auto w-16' src='/logo.svg' alt='logo' />
          </NavLink>
          <div className='flex items-center'>
            <div className='hidden lg:block'>
              <ul className='mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center'>
                {navigationList?.map((list) =>
                  !list?.children ? (
                    <Typography
                      key={`navigationList${list?.id}`}
                      as='li'
                      variant='small'
                      color='blue-gray'
                      className='p-1 font-medium tracking-wide capitalize flex items-center cursor-pointer'>
                      <NavLink
                        to={list?.url}
                        className={`activeLink flex items-center text-white tracking-wider hover:text-white ${({
                          isActive,
                        }) => (isActive ? 'active' : 'inactive')}`}>
                        {list?.label}
                      </NavLink>
                    </Typography>
                  ) : (
                    list?.children?.length > 0 && (
                      <Menu
                        className='relative'
                        handler={() => setIsShown(!isShown)}
                        open={
                          isShown && menuName === list?.label ? true : false
                        }>
                        <MenuHandler>
                          <Typography
                            key={`childrenList${list?.id}`}
                            as='li'
                            variant='small'
                            color='blue-gray'
                            className='p-1 font-medium tracking-wide capitalize flex items-center cursor-pointer relative'>
                            <span
                              onClick={() => {
                                setIsShown(!isShown);
                                setMenuName(list?.label);
                              }}
                              className={classNames(
                                currentUrl?.includes(
                                  `/${list?.url?.slice(1).toLowerCase()}`
                                )
                                  ? 'activeLink active font-bold'
                                  : 'text-white',
                                'flex items-center text-white hover:text-white'
                              )}
                              aria-current={
                                currentUrl?.includes(
                                  `/${list?.url?.slice(1).toLowerCase()}`
                                )
                                  ? 'page'
                                  : undefined
                              }>
                              {list?.label}
                              <BiChevronDown color='white' size={20} />
                            </span>
                            {isShown && list?.label === menuName && (
                              <RiArrowUpSFill
                                size={35}
                                fill='white'
                                className='absolute block left-5 -bottom-5'
                              />
                            )}
                          </Typography>
                        </MenuHandler>
                        {isShown && (
                          <DropDownMenuCard
                            data={list}
                            currentUrl={currentUrl}
                          />
                        )}
                      </Menu>
                    )
                  )
                )}
              </ul>
            </div>
            <select
              name='language'
              id='language'
              className='bg-transparent hidden lg:inline-block cursor-pointer ml-3'>
              <option className='text-black' value='EN'>
                EN
              </option>
              <option className='text-black' value='FR'>
                FR
              </option>
              <option className='text-black' value='UR'>
                UR
              </option>
            </select>
          </div>
          <IconButton
            variant='text'
            className='ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden'
            ripple={false}
            onClick={() => setOpenNav(!openNav)}>
            {openNav ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                className='h-6 w-6'
                viewBox='0 0 24 24'
                stroke='currentColor'
                strokeWidth={2}>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>
            ) : (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='none'
                stroke='currentColor'
                strokeWidth={2}>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M4 6h16M4 12h16M4 18h16'
                />
              </svg>
            )}
          </IconButton>
        </div>
        <MobileNav open={openNav}>
          <ul className='mb-2 mt-2 flex flex-col gap-1 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center overflow-y-auto'>
            {navigationList?.map((list) =>
              !list?.children ? (
                <Typography
                  key={`navigationList${list?.id}`}
                  as='li'
                  variant='small'
                  color='blue-gray'
                  className='p-1 font-medium tracking-wide capitalize flex items-center cursor-pointer'>
                  <NavLink
                    to={list?.url}
                    className={`activeLink flex items-center text-white tracking-wider hover:text-white ${({
                      isActive,
                    }) => (isActive ? 'active' : 'inactive')}`}>
                    {list?.label}
                  </NavLink>
                </Typography>
              ) : (
                list?.children?.length > 0 && (
                  <Menu>
                    <MenuHandler>
                      <Typography
                        key={`childrenList${list?.id}`}
                        as='li'
                        variant='small'
                        color='blue-gray'
                        className='p-1 w-48 text-sm font-medium tracking-wide capitalize flex items-center cursor-pointer relative'>
                        <span
                          onClick={() => {
                            setMenuName(list?.label);
                          }}
                          className={classNames(
                            currentUrl?.includes(
                              `/${list?.url?.slice(1).toLowerCase()}`
                            ) && 'activeLink active font-bold',
                            'flex items-center text-white hover:text-white'
                          )}
                          aria-current={
                            currentUrl?.includes(
                              `/${list?.url?.slice(1).toLowerCase()}`
                            )
                              ? 'page'
                              : undefined
                          }>
                          {list?.label}
                          <BiChevronDown color='white' size={20} />
                        </span>
                      </Typography>
                    </MenuHandler>
                    <MenuList className='bg-white outline-none border-none'>
                      {list?.children?.map((items) => (
                        <NavLink to={items?.url}>
                          <MenuItem
                            key={`submenusList${items?.id}`}
                            className='capitalize pb-1 text-eventLightYellow text-base tracking-wider hover:text-eventLightYellow hover:bg-transparent font-medium'>
                            <NavLink
                              to={items?.url}
                              className={classNames(
                                currentUrl?.includes(
                                  `/${items?.url?.slice(1).toLowerCase()}`
                                ) && 'font-semibold',
                                'activeLink flex items-center group text-eventLightYellow hover:text-eventLightYellow'
                              )}>
                              <span
                                className={classNames(
                                  currentUrl?.includes(
                                    `/${items?.url?.slice(1).toLowerCase()}`
                                  )
                                    ? 'bg-eventPink'
                                    : 'bg-eventLightGray',
                                  'w-10 h-10 mr-3 rounded-full flex items-center justify-center'
                                )}>
                                {items?.icon}
                              </span>{' '}
                              {items?.label}
                            </NavLink>
                          </MenuItem>
                        </NavLink>
                      ))}
                    </MenuList>
                  </Menu>
                )
              )
            )}
          </ul>
          <select
            name='language'
            id='language'
            className='bg-transparent block lg:hidden cursor-pointer'>
            <option className='text-black' value='EN'>
              EN
            </option>
            <option className='text-black' value='FR'>
              FR
            </option>
            <option className='text-black' value='UR'>
              UR
            </option>
          </select>
        </MobileNav>
      </Navbar>
    </section>
  );
};
export default Header;
